import { Teammate } from "../Team";

export class TeamReviewMemberOrder{
    teamReviewSettingsId: string = "";
    teamMemberId: string = "";
    position: number = 0;
    firstName: string = "";
    lastName: string = "";
}